export enum LogoEnum{
  SAFECALL,
  SAFECALL_PRO,
  SAFECALL_GO,
  SAFEMATE,
  SAFEMATE_PRO,
  SAFEMATE_GO
}